export function restanteDe(emMs: number): number {
  if (!emMs) return 0;
  return Math.max(0, Math.floor((emMs - Date.now()) / 1000));
}

export function formatar(s: number): string {
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

export function formatarLongo(s: number): string {
  if (s >= 3600) {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return `${h}h${m.toString().padStart(2, '0')}`;
  }
  return formatar(s);
}
